module.exports = ".alert.alert-danger {\n  margin-top: 5px;\n  margin-bottom: 0px; }\n  .alert.alert-danger p {\n    font-size: 10px;\n    font-weight: bold;\n    line-height: 12px;\n    text-transform: uppercase; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/form/components/messages/messages.component.scss
// module id = ./libs/chassis-core/src/app/forms/form/components/messages/messages.component.scss
// module chunks = main